export default {
  api: null,
  map: null,
};
